export default {
  data: {},
  props: {
    tabs: {
      origin: {},
      panes: {
        trashedUsers: {
          origin: {
            label: "Trashed Users",
            name: "TrashedUsers",
            group: "TrashedUsers",
            ":lazy": true,
          },
        },
      },
    },
  },
};
